import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get(conversationId) {
    const params = conversationId ? { conversation_id: conversationId } : {};
    return super.get(params);
  }

  cancel(id) {
    return this.post(`${this.url}/${id}/cancel`);
  }
}

export default new ScheduledMessagesAPI();